module.exports = __webpack_public_path__ + "img/huitre-en-ligne-boutrais_small.15a9aefe.png";